<template>
	<form @submit.prevent="submit">
		<slot
			:json="json"
			:state="state"
			:response="response"
		/>
	</form>
</template>

<script>
export default {
	props: {
		config: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			state: null,
			response: null,
			json: {},
		};
	},
	methods: {
		async submit( { target: form } ) {
			this.state = null;
			this.response = null;

			await this.$nextTick();

			const formData = new FormData( form );
			const resource = new URL( form.action );
			const { method } = form;
			const init = {
				method,
				// headers: { 'X-Requested-With': 'XMLHttpRequest' },
				mode: 'cors',
			};

			if ( method === 'get' ) {
				for ( const [ key, value ] of formData.entries() ) {
					resource.searchParams.append( key, value );
				}
			} else {
				init.body = formData;
			}

			resource.searchParams.append( 'userid', '206059' );
			resource.searchParams.append( '_', +( new Date() ) );

			Object.assign( init, this.config );

			this.state = 'pending';

			try {
				this.response = await fetch( resource, init );
			} catch ( exception ) {
				this.state = 'rejected';

				return;
			}

			this.json = await this.response.json();

			this.state = 'fulfilled';
		},
	},
};
</script>
